import { PropsWithChildren, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type RequireQueryProps = PropsWithChildren<{
  required: string[]; // ["userId", "userNameSurname"] gibi
  redirectTo: string; // örn: provideUrl(AppRouteKey.LOGIN)
  validate?: (params: URLSearchParams) => boolean; // opsiyonel ek doğrulama
}>;

export default function RequireQuery({
  required,
  redirectTo,
  validate,
  children,
}: RequireQueryProps) {
  const { search } = useLocation();

  const { ok, params } = useMemo(() => {
    const p = new URLSearchParams(search);
    const hasAll = required.every((k) => {
      const v = p.get(k);
      return v !== null && v.trim().length > 0;
    });
    const valid = validate ? validate(p) : true;
    return { ok: hasAll && valid, params: p };
  }, [search, required, validate]);

  if (!ok) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
